// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.img_container .myImage {
  width: 100%;
  height: 100%;
  background-position: center !important;
  background-size: cover !important;
  background-image: url("/assets/img/default/ec_commodity_default.png");
}

.product-desc {
  padding-left: calc(10 * var(--width-ratio));
  padding-top: calc(10 * var(--width-ratio));
  padding-right: calc(10 * var(--width-ratio));
}
.product-desc .product-price {
  margin-top: calc(3 * var(--width-ratio));
}
.product-desc .ori-price {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: calc(13 * var(--width-ratio));
  line-height: calc(22 * var(--width-ratio));
  text-decoration-line: line-through;
}
.product-desc .discount-div {
  background: rgba(var(--ion-color-warning-rgb), 0.3);
  border-radius: 20px;
  padding-left: calc(10 * var(--width-ratio));
}

.buttons-div {
  width: 100%;
  height: calc(46 * var(--width-ratio));
  background: rgba(162, 146, 193, 0.1);
  border-top-left-radius: 40px;
  border-bottom-left-radius: 40px;
}
.buttons-div .mybutton {
  height: unset;
  margin: unset;
}
.buttons-div .mybutton ion-icon {
  width: calc(24 * var(--width-ratio));
  height: calc(24 * var(--width-ratio));
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/product-list-item3/product-list-item3.component.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,iCAAA;EACA,qEAAA;AAAJ;;AAIA;EACE,2CAAA;EACA,0CAAA;EACA,4CAAA;AADF;AAIE;EACE,wCAAA;AAFJ;AAKE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;EACA,0CAAA;EACA,kCAAA;AAHJ;AAME;EACE,mDAAA;EACA,mBAAA;EAGA,2CAAA;AANJ;;AAUA;EACE,WAAA;EACA,qCAAA;EACA,oCAAA;EACA,4BAAA;EACA,+BAAA;AAPF;AASE;EACE,aAAA;EACA,aAAA;AAPJ;AAcI;EACE,oCAAA;EACA,qCAAA;AAZN","sourcesContent":[".img_container {\n  .myImage {\n    width: 100%;\n    height: 100%;\n    background-position: center !important;\n    background-size: cover !important;\n    background-image: url(\"/assets/img/default/ec_commodity_default.png\");\n  }\n}\n\n.product-desc {\n  padding-left: calc(10 * var(--width-ratio));\n  padding-top: calc(10 * var(--width-ratio));\n  padding-right: calc(10 * var(--width-ratio));\n  //padding-bottom: calc(10 * var(--width-ratio));\n\n  .product-price {\n    margin-top: calc(3 * var(--width-ratio));\n  }\n\n  .ori-price {\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: calc(13 * var(--width-ratio));\n    line-height: calc(22 * var(--width-ratio));\n    text-decoration-line: line-through;\n  }\n\n  .discount-div {\n    background: rgba(var(--ion-color-warning-rgb), 0.3);\n    border-radius: 20px;\n    //padding-top: calc(4 * var(--width-ratio));\n    //padding-bottom: calc(4 * var(--width-ratio));\n    padding-left: calc(10 * var(--width-ratio));\n  }\n}\n\n.buttons-div {\n  width: 100%;\n  height: calc(46 * var(--width-ratio));\n  background: rgba(162, 146, 193, 0.1);\n  border-top-left-radius: 40px;\n  border-bottom-left-radius: 40px;\n\n  .mybutton {\n    height: unset;\n    margin: unset;\n    // --padding-end: unset;\n    // --padding-start: unset;\n    // margin-left: 20px;\n\n    //background-color: yellow;\n\n    ion-icon {\n      width: calc(24 * var(--width-ratio));\n      height: calc(24 * var(--width-ratio));\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
